import { render, staticRenderFns } from "./GenericErrorModal.vue?vue&type=template&id=6ed6e12c&"
import script from "./GenericErrorModal.vue?vue&type=script&lang=js&"
export * from "./GenericErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports